import { Box } from '@mui/material';
import WebsiteLogo from "../../assets/image/logo.png"

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  return (
    <Box
      component={"img"}
      src={WebsiteLogo}
      // height={80}
      width={180}
    />
  );
}
